import { render, staticRenderFns } from "./uploadPaymentInvoiceComponent.vue?vue&type=template&id=05c10cbe&"
import script from "./uploadPaymentInvoiceComponent.vue?vue&type=script&lang=js&"
export * from "./uploadPaymentInvoiceComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports